import { AokCardViewModel } from './aok-card-view-model';

export class NewsViewModel extends AokCardViewModel {
    category?: string | undefined;
    validFrom?: Date | undefined;
    validFromFormatted?: string | undefined;
    formattedContent?: string | undefined;
}